if (
  typeof String !== undefined &&
  String.prototype &&
  !String.prototype.isTimestamp
) {
  Object.defineProperty(String.prototype, 'isTimestamp', {
    value() {
      return this.match(/^(?:(?:([01]?\d|2[0-3]):)?([0-5]?\d):)?([0-5]?\d)(\.\d+)?$/g);
    }
  });
}